/** 12.5 → "0:12.50" */
export function formatTime(seconds: number): string {
  if (!Number.isFinite(seconds)) return '0:00.00'
  const sign = seconds < 0 ? '-' : ''
  const abs = Math.abs(seconds)
  const minutes = Math.floor(abs / 60)
  const rest = abs - minutes * 60
  return `${sign}${minutes}:${rest.toFixed(2).padStart(5, '0')}`
}

/** 12.5 → "0:12" — компактный вариант для линейки таймлайна. */
export function formatTimeShort(seconds: number): string {
  if (!Number.isFinite(seconds)) return '0:00'
  const abs = Math.max(0, Math.floor(seconds))
  const minutes = Math.floor(abs / 60)
  const rest = abs - minutes * 60
  return `${minutes}:${String(rest).padStart(2, '0')}`
}

export function formatMs(seconds: number): string {
  const ms = Math.round(seconds * 1000)
  return `${ms > 0 ? '+' : ''}${ms} мс`
}

export function formatDb(db: number): string {
  return `${db > 0 ? '+' : ''}${db.toFixed(1)} дБ`
}

export function formatBytes(bytes: number): string {
  if (bytes < 1024) return `${bytes} Б`
  if (bytes < 1024 * 1024) return `${(bytes / 1024).toFixed(1)} КБ`
  if (bytes < 1024 * 1024 * 1024) return `${(bytes / 1024 / 1024).toFixed(1)} МБ`
  return `${(bytes / 1024 / 1024 / 1024).toFixed(2)} ГБ`
}

export function formatDateTime(iso: string): string {
  const date = new Date(iso)
  if (Number.isNaN(date.getTime())) return iso
  return date.toLocaleString('ru-RU', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
  })
}

export function clamp(value: number, min: number, max: number): number {
  return Math.min(max, Math.max(min, value))
}

/** Парсит "1:23.45" или "83.45" в секунды. null — если не разобрали. */
export function parseTime(input: string): number | null {
  const trimmed = input.trim().replace(',', '.')
  if (!trimmed) return null
  const parts = trimmed.split(':')
  if (parts.length === 1) {
    const value = Number(parts[0])
    return Number.isFinite(value) ? value : null
  }
  if (parts.length === 2) {
    const minutes = Number(parts[0])
    const seconds = Number(parts[1])
    if (!Number.isFinite(minutes) || !Number.isFinite(seconds)) return null
    return minutes * 60 + seconds
  }
  return null
}
